export * from "./components/CommandPalette";
export * from "./lib/utils";
export * from "./types";

import CommandPalette from "./components/CommandPalette";

export default CommandPalette;
